import {Routes} from '@angular/router';

import {AuthLayout, HOME_ROUTE, UserRole, allowRolesGuard, authGuard} from '@core/auth';
import {MainLayout} from '@core/layout';
import {APP_ROUTES} from '@core/routes';

export const routes: Routes = [
  {
    path: APP_ROUTES.root,
    redirectTo: HOME_ROUTE,
    pathMatch: 'full',
  },
  {
    path: '',
    component: AuthLayout,
    children: [
      {
        path: APP_ROUTES.login,
        loadComponent: () => import('@core/auth/pages/login/login').then((m) => m.Login),
      },
      {
        path: APP_ROUTES.register,
        loadComponent: () => import('@core/auth/pages/register/register').then((m) => m.Register),
      },
      {
        path: APP_ROUTES.forgotPassword,
        loadComponent: () => import('@core/auth/pages/forgot-password/forgot-password').then((m) => m.ForgotPassword),
      },
      {
        path: APP_ROUTES.resetPassword,
        loadComponent: () => import('@core/auth/pages/reset-password/reset-password').then((m) => m.ResetPassword),
      },
      {
        path: APP_ROUTES.setPassword,
        loadComponent: () => import('@core/auth/pages/set-password/set-password').then((m) => m.SetPassword),
      },
    ],
  },
  {
    path: '',
    component: MainLayout,
    canActivate: [authGuard],
    children: [
      {
        path: APP_ROUTES.orders.root,
        loadChildren: () => import('@features/orders/orders.routes').then((m) => m.ordersRoutes),
      },
      {
        path: APP_ROUTES.customers,
        loadChildren: () => import('@features/customers/customers.routes').then((m) => m.customersRoutes),
      },
      {
        path: APP_ROUTES.personnel.root,
        canActivate: [allowRolesGuard(UserRole.Admin)],
        loadChildren: () => import('@features/personnel/personnel.routes').then((m) => m.personnelRoutes),
      },
      {
        path: APP_ROUTES.settings.root,
        loadChildren: () => import('@features/settings/settings.routes').then((m) => m.settingsRoutes),
      },
    ],
  },
  {
    path: '**',
    redirectTo: HOME_ROUTE,
  },
];
